// extracted by mini-css-extract-plugin
export var quantityInput = "_oo-0";